import React from 'react';
import styled from '@emotion/styled';
import { css, Theme } from '@emotion/react';
import { rem } from 'polished';
import {
  animations,
  colors,
  mixins,
  shadows,
} from '../../../core/styles/theme/default';
import { LinkContent } from '../partials';
import { LinkProps } from '../Link';
import classNames from 'classnames';

const StyledLink = styled(LinkContent)(
  ({ isLarge, theme }: { isLarge?: boolean; theme?: Theme }) => css`
    position: relative;
    border-radius: ${rem(2)};
    overflow: hidden;
    transition: box-shadow ${animations.default};
    border-radius: ${rem(4)};
    background-color: ${colors.white};
    border: ${rem(1)} solid ${colors.grue300};

    &:hover,
    &:focus {
      box-shadow: ${shadows.dropDownHover};
    }

    ${mixins.responsiveStyles({
      padding: { zero: 16, wide: 24 },
      'padding-top': { zero: 80, wide: 108 },
      'font-size': { zero: 16, wide: 20 },
      'line-height': { zero: 20, wide: 24 },
    })}

    ${isLarge &&
    css`
      ${mixins.responsiveStyles({
        padding: { wide: 16 },
        'padding-top': { zero: 96, medium: 174, wide: 194 },
        'font-size': { wide: 16 },
        'line-height': { wide: 20 },
      })}
    `}

    .label {
      z-index: 1;
      font-size: inherit;
      line-height: inherit;
    }

    ${theme?.stylesExtension?.link?.tile}
  `,
);

const LinkTile = ({
  iconAfter = 'AnimatedIconArrowRight',
  className,
  ...rest
}: LinkProps) => {
  return (
    <StyledLink
      iconAfter={iconAfter}
      className={classNames('animate', className)}
      {...rest}
    />
  );
};

export default LinkTile;
